'use client'

import { useRouter } from 'next/navigation'
import { ComponentType, SVGProps } from 'react'

import {
  SafeRental,
  ReasonableContract,
  FastVacancyResolution,
} from '@/shared/asset'
import { SignUpIntro } from '@/widgets/sign-up'

const content: {
  title: string
  description: string
  image: ComponentType<SVGProps<SVGSVGElement>>
}[] = [
  {
    title: '안전한 계약',
    description: '삼삼엠투가 모든 계약의\n안전한 입주 여부를 확인합니다.',
    image: SafeRental,
  },
  {
    title: '빠른 계약',
    description:
      '계약 요청 > 승인 > 결제\n3단계 절차만으로 계약할 수 있습니다.',
    image: FastVacancyResolution,
  },
  {
    title: '합리적인 계약',
    description:
      '장기 계약 부담 없이 1주 단위로\n원하는 만큼만 계약할 수 있습니다.',
    image: ReasonableContract,
  },
]

export const SignUpGuestIntro = () => {
  const router = useRouter()

  const handleButtonClick = () => {
    router.push('/sign-up/guest?step=terms')
  }

  return (
    <SignUpIntro
      title="잠깐 살 집을 찾아보세요"
      content={content}
      buttonText="게스트로 회원가입"
      onButtonClick={handleButtonClick}
    />
  )
}
